// Pre-select the service on the quote form when arriving from a service page (?service=Title)
document.addEventListener('DOMContentLoaded', () => {
  const select = document.querySelector('[data-service-select]');
  if (!select) return;

  const service = new URLSearchParams(window.location.search).get('service');
  if (!service) return;

  const match = Array.from(select.options).find((option) => option.value === service);
  if (match) select.value = service;
});
